import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const Li = styled.li`
  margin-left: ${layout.measurements.spacing100};

  ::marker {
    color: ${props => props.theme.text.callToAction};
  }
  && {
    margin-bottom: ${layout.measurements.spacing050};
  }
`;

export const Ul = styled.ul``;

export const UnStyledUl = styled.ul`
  list-style: none;
  > ${Li} {
    margin-left: 0;
  }
`;
